/*
    *Author:卢迪
    //有事请找我
*/
import React, { Component } from 'react';
import { ArrowItem } from '@beisen/chaos-ui';

import PanelTree from './PanelTree';
import * as uiUtil from '../../util/ui';
import transLoader from '@beisen/i18n-translation-loader';
const defaultTranslation = {
    dataFaildTip: '请求数据失败',
    select: '请选择',
    clear: '清空',
    confirm: '确定',
    cancel: '取消',
    selectHolder: '点击选择',
    required: '必填'
};
class PopTree extends Component {
    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleTouchTap = this.handleTouchTap.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);

        this.handleClearValue = this.handleClearValue.bind(this);
        this.afterClose = this.afterClose.bind(this);
        this.state = {
            showPopUp: false, //是否显示panel
            errorMsg: '',
            visible: false,
            isCancle: true
        };
        this.translation = Object.assign(
            {},
            defaultTranslation,
            transLoader({
                dataFaildTip: 'tip.dataFaildTip',
                select: 'fieldPlaceHolder.select',
                clear: 'common.clear',
                confirm: 'common.confirm',
                cancel: 'common.cancel',
                selectHolder: 'fieldPlaceHolder.selectHolder',
                required: 'common.required'
            }),
            props.translation
        );
    }

    componentWillMount() {
        if (this.props.pop_type == 'searchItem') {
            this.setState({ showPopUp: true });
        }

        this.height = document.documentElement.clientHeight - 88;
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.pop_type == 'searchItem' && nextProps.visible) {
            this.setState({ showPopUp: true });
        }
    }

    handleTouchTap(e, item) {
        this.setState({ showPopUp: true, visible: true }, () => {
            this.props.onFocus && this.props.onFocus();
        });
    }

    handleCancel() {
        if (this.props.pop_type == 'searchItem') {
            this.props.handleCancel && this.props.handleCancel();
        }
        this.setState({ visible: false });
    }

    handleConfirm(item) {
        let orgInfo = {};
        const { cmp_type, formType, cmp_data } = this.props;
        //部门单选筛选状态需要value需要拼接|4代表包含下级
        if (
            cmp_type === 'BC_SingleDepartmentSearch' &&
            formType === 'searchForm'
        ) {
            let val = item.id + '|4';
            orgInfo = { text: (item && item.name) || '', value: val };
        } else {
            if (
                cmp_data.hasOwnProperty('usepathsearch') &&
                cmp_data.usepathsearch === 'true'
            ) {
                let val =
                    item.id +
                    '|' +
                    item.path +
                    '|' +
                    item.level +
                    (formType === 'searchForm' ? '|4' : '');
                orgInfo = { text: (item && item.name) || '', value: val };
            } else {
                orgInfo = {
                    text: (item && item.name) || '',
                    value: item ? item.id : ''
                };
            }
        }

        this.data = orgInfo;
        if (this.props.pop_type == 'searchItem') {
            this.props.handleClosePopUp && this.props.handleClosePopUp();
            this.setState({ isCancle: false });
        } else {
            this.setState({ visible: false, isCancle: true }, () => {
                this.props.onChange && this.props.onChange(orgInfo);
            });
        }
    }

    handleClearValue() {
        this.data = { text: '', value: '' };
        if (this.props.pop_type == 'searchItem') {
            this.props.handleClosePopUp && this.props.handleClosePopUp();
            this.setState({ isCancle: false });
        } else {
            this.setState({ visible: false, isCancle: true }, () => {
                this.props.onChange &&
                    this.props.onChange({ text: '', value: '' });
            });
        }
    }

    afterClose() {
        if (!this.state.isCancle) {
            this.props.onChange && this.props.onChange(this.data);
            this.props.synBizData && this.props.synBizData();
        }
        this.setState({ showPopUp: false });
    }

    renderNormalPopTree() {
        let {
            cmp_label,
            form_context,
            cmp_data,
            errorMessage,
            desc
        } = this.props;
        const errMsg = errorMessage && errorMessage.message;
        return (
            <div>
                <ArrowItem
                    label={this.props.label}
                    type="text"
                    isReadOnly={this.props.isReadOnly}
                    onClickForm={this.handleTouchTap}
                    required={this.props.required}
                    value={this.props.text}
                    errorMsg={errMsg}
                    desc={desc}
                    translation={this.translation}
                    styleTitle={this.props.styleTitle}
                />
                {this.state.showPopUp ? (
                    <PanelTree
                        title={uiUtil.strEllipsis(this.props.label)}
                        datasourceUrl={cmp_data.datasourceurl}
                        datasourcename={cmp_data.datasourcename}
                        metaObjName={form_context.metaObjName}
                        handleConfirm={this.handleConfirm}
                        handleCancel={this.handleCancel}
                        onClearValue={this.handleClearValue}
                        formState={cmp_data.cmp_state}
                        pop_type={this.props.pop_type}
                        visible={this.state.visible}
                        afterClose={this.afterClose}
                        showTip={this.props.actions.showTip}
                        cmp_data={this.props.cmp_data}
                        translation={this.translation}
                    />
                ) : null}
            </div>
        );
    }

    renderSearchItemPopTree() {
        let { cmp_label, form_context, cmp_data } = this.props;
        return this.state.showPopUp ? (
            <PanelTree
                style={{ height: this.height }}
                title={uiUtil.strEllipsis(this.props.label)}
                datasourceUrl={cmp_data.datasourceurl}
                datasourcename={cmp_data.datasourcename}
                metaObjName={form_context.metaObjName}
                handleConfirm={this.handleConfirm}
                handleCancel={this.handleCancel}
                onClearValue={this.handleClearValue}
                formState={cmp_data.cmp_state}
                pop_type={this.props.pop_type}
                afterClose={this.afterClose}
                visible={this.props.visible}
                showTip={this.props.actions.showTip}
                cmp_data={this.props.cmp_data}
                translation={this.translation}
            />
        ) : null;
    }

    render() {
        return this.props.pop_type == 'searchItem'
            ? this.renderSearchItemPopTree()
            : this.renderNormalPopTree();
    }
}

export default PopTree;



// WEBPACK FOOTER //
// ./src/components/Field_Components/PopTree/PopTree.js